module.exports = __webpack_public_path__ + "img/ico-tiktok-circle.944a7ac4.png";